module.exports = __webpack_public_path__ + "static/media/wave.67cf2864.svg";